import queryString from 'query-string'

import Base from './base'

type GetActivitiesOptions = {
  params: {
    email: string
  }
}

type SearchReferencesOptions = {
  params: {
    crm_id?: number
    criteria?: string
    type?: string
  }
}

export default class CrmReferences extends Base {
  get({ params }: GetActivitiesOptions): Promise<unknown> {
    return this.api.get(`crm_activity_references?${queryString.stringify({ email: params.email })}`)
  }

  search({ params }: SearchReferencesOptions): Promise<unknown> {
    if (params.crm_id) {
      return this.api.get(`crm_object_references?crm_id=${params.crm_id}`)
    }

    return this.api.get(`crm_object_references?criteria=${params.criteria}&type=${params.type}`)
  }

  set({ body }: { body: string }): Promise<unknown> {
    return this.api.post(`crm_activity_references`, body)
  }
}
